import { render, staticRenderFns } from "./paper-review.vue?vue&type=template&id=afccf120"
import script from "./paper-review.vue?vue&type=script&lang=js"
export * from "./paper-review.vue?vue&type=script&lang=js"
import style0 from "./paper-review.vue?vue&type=style&index=0&id=afccf120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports